import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {

  @Input() filterstatus: string = "ALL";
  @Input() formname: string = "";
    
  @Output() cbapplyChanged = new EventEmitter();
  @Output() filterChanged = new EventEmitter<number>();

  statusColl: any = [];


  
  constructor() { }

  ngOnInit() {
    this.fngetStatus();
  }

  
  fngetStatus() {   
    this.statusColl.push({ displayname: "Active", value: "" });
    this.statusColl.push({ displayname: "InActive", value: "INACTIVE" });
    this.statusColl.push({ displayname: "All", value: "ALL" });
  }

  fnApplyFilter()
  {
    
    var _data = {
      status:this.filterstatus
    }

    this.cbapplyChanged.emit(_data);

    
  }


  fnResetFilter()
  {
    
    var _data = {
      status:""
    }

    this.cbapplyChanged.emit(_data);

    
  }


}
